import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import IconSecurityLocker from 'components/_special/IconSecurityLocker'
import List, { ListItem } from 'components/List'
import { H2 } from 'styles/components/typography'

import { SectionWrapperStyled, TextStyled } from './styles'

const WHowProtection = ({ data }) => {
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapperStyled className="d-md-flex align-items-md-center">
      <div className="row py-4 py-md-0 align-items-center">
        <div className="col-12 col-md-6">
          <IconSecurityLocker
            iconBgColor={colors.wePeepOp1}
            icon="lockerLight"
          />
        </div>
        <div className="col-12 col-md-6 mt-4 mt-md-0 text--white py-md-4">
          <H2 dangerouslySetInnerHTML={{ __html: data.title }} />
          <TextStyled dangerouslySetInnerHTML={{ __html: data.content }} />
          <List leftAlignment="text">
            {data.list.map((item, id) =>
              item ? (
                <ListItem
                  className="text--white with-inverted-links"
                  key={`protection.${id}`}
                  bulletColor="white"
                >
                  {item}
                </ListItem>
              ) : null,
            )}
          </List>
        </div>
      </div>
    </SectionWrapperStyled>
  )
}

WHowProtection.propTypes = {
  data: PropTypes.object.isRequired,
}

WHowProtection.defaultProps = {}

export default WHowProtection
